'use client'

import { HeroSectionProps } from '@/widgets/landing-page-widgets/hero-section/schema'
import { Button, Typography } from '@pw-tech/omni-ui'
import Image from 'next/image'

import { UNDERLINE_IMAGE } from '../contants'

const HeroSection = ({
  handleOpenBookDemoModal,
  heroSectionData,
}: {
  handleOpenBookDemoModal: ({ clickFrom }: { clickFrom: string }) => void
  heroSectionData: HeroSectionProps
}) => {
  return (
  <div className="relative pt-[80px] md:pt-[60px]">
      {heroSectionData?.backgroundImage && (
        <Image
          src={heroSectionData.backgroundImage}
          alt='' /* decorative */
          role='presentation'
          fill
          sizes='100vw'
          decoding='async'
          className='object-cover object-left sm:object-top'
          priority
          fetchPriority='high'
        />
      )}

  <div className="relative max-w-6xl mx-auto px-4 md:px-6" id='goal-selection-container'>
  <div className="flex flex-col gap-4 md:flex-row md:justify-between">
          <div className="flex flex-col gap-10 mb-6 items-center md:items-stretch md:max-w-md">
            <div className="flex flex-col gap-3 min-h-[10px]">
              <Typography variant='heading1' weight='bold' className="text-center md:text-start" color='#1b2124'>
                {heroSectionData?.heading}
              </Typography>
              <Typography variant='heading4' weight='medium' className="text-center md:text-start" color='#3d3d3d'>
                {heroSectionData?.subHeading}
              </Typography>
            </div>
            <div className="text-center md:text-start">
              <span className='relative'>
                <Typography variant='heading4' weight='bold' component='span' color='#1b2124'>
                  {heroSectionData?.classSubHeading}
                </Typography>
                <div className="absolute left-[-4px] right-[-2px] bottom-[-12px]">
                  <Image src={UNDERLINE_IMAGE} width={231} height={15} alt='' priority />
                </div>
              </span>
            </div>

            <Button
              className="md:self-start self-center cursor-pointer bg-gradient-to-b from-[#ff9d5b] to-[#ff6d0a] transition-all"
              size='large'
              onClick={() => handleOpenBookDemoModal({ clickFrom: 'hero_section' })}
            >
              {heroSectionData?.learningProgramButtonText}
            </Button>
          </div>
          <div className="md:max-w-[472px] max-w-[344px] w-full relative md:mx-0 mx-auto aspect-[1040/848]">
            <Image
              src={heroSectionData?.bannerImage}
              width={1040}
              height={848}
              alt='hero-image'
              sizes='(max-width: 768px) 100vw, 1040px'
              priority
              fetchPriority='high'
              style={{ width: '100%', height: 'auto' }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeroSection
